// frontend/src/utils/crypto.js
async function deriveKey(password, salt) {
    const encoder = new TextEncoder();
    const baseKey = encoder.encode(password); // Use the actual password passed from login
    const keyMaterial = await crypto.subtle.importKey(
      'raw',
      baseKey,
      { name: 'PBKDF2' },
      false,
      ['deriveKey']
    );
    return crypto.subtle.deriveKey(
      {
        name: 'PBKDF2',
        salt: encoder.encode(salt),
        iterations: 100000,
        hash: 'SHA-256',
      },
      keyMaterial,
      { name: 'AES-GCM', length: 256 },
      false,
      ['encrypt', 'decrypt']
    );
  }
  
  export async function encrypt(text, password, salt) {
    const key = await deriveKey(password, salt);
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const encrypted = await crypto.subtle.encrypt(
      { name: 'AES-GCM', iv },
      key,
      data
    );
    const encryptedArray = new Uint8Array(encrypted);
    const result = new Uint8Array(iv.length + encryptedArray.length);
    result.set(iv);
    result.set(encryptedArray, iv.length);
    return Array.from(result)
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  }
  
  export async function decrypt(encryptedHex, password, salt) {
    const key = await deriveKey(password, salt);
    const encryptedBytes = new Uint8Array(
      encryptedHex.match(/.{1,2}/g).map((byte) => parseInt(byte, 16))
    );
    const iv = encryptedBytes.slice(0, 12);
    const data = encryptedBytes.slice(12);
    const decrypted = await crypto.subtle.decrypt(
      { name: 'AES-GCM', iv },
      key,
      data
    );
    const decoder = new TextDecoder();
    return decoder.decode(decrypted);
  }